import { LatLngExpression } from 'leaflet';
import { SetStateAction, createContext } from 'react';
import { AddressFull } from '../containers/types';
import { ErrorType } from '../types';

export type GlobalContent = {
  address: AddressFull | null
  inBounds: ErrorType
  categories: any[],
  subcategories: any[],
  latlng: LatLngExpression | null,
  validationSchema: any,
  initialValues: any,
  categoryId: number,
  alert: any,
  updateAddress: React.Dispatch<SetStateAction<null>>
  updateInBounds: React.Dispatch<SetStateAction<ErrorType>>
  updateCategories: React.Dispatch<SetStateAction<never[]>>
  updateSubcategories: React.Dispatch<SetStateAction<never[]>>
  updateLatLng: React.Dispatch<SetStateAction<null>>
  updateValidationSchema: (schema: any) => void
  updateInitialValues: (values: any) => void
  updateCategoryId: (id: number) => void
  updateAlert: (alert: any) => void
};

const AddressContext = createContext<GlobalContent>({
  address: null,
  updateAddress: () => {},
  inBounds: '',
  updateInBounds: () => {},
  categories: [],
  updateCategories: () => {},
  subcategories: [],
  updateSubcategories: () => {},
  latlng: null,
  updateLatLng: () => {},
  validationSchema: null,
  updateValidationSchema: () => {},
  initialValues: {},
  updateInitialValues: () => {},
  categoryId: 0,
  updateCategoryId: () => {},
  alert: {},
  updateAlert: () => {},
});

export default AddressContext;
